<template lang="html">
  <div
    id="actionModal"
    class="action modal fade"
    data-backdrop="false"
    tabindex="-1"
    role="dialog">
    <div class="modal-dialog" role="document">
      <div class="modal-content pt-5 pb-4 px-3 p-sm-5">
        <button
          v-if="ignoreLabel || !noClose"
          class="close action-close text-secondary"
          data-dismiss="modal"
          aria-label="Close">
          <font-awesome-icon :icon="[ 'fas', 'times' ]" />
        </button>
        <div class="modal-body text-center">
          <div class="pb-2">
            <font-awesome-icon v-if="error" :icon="[ 'fas', 'exclamation-triangle' ]" size="5x" color="#E10000" />
            <font-awesome-icon v-else-if="maintenance" :icon="[ 'fas', 'wrench' ]" size="5x" color="#CCCCCC" />
            <m-icon v-else icon="message" :scale="3"/>
          </div>
          <h3 class="h3 pt-3 pb-2">{{ header }}</h3>
          <div v-if="html" v-html="statement"></div>
          <p v-else>{{ statement }}</p>
        </div>
        <div class="text-center d-flex d-sm-block">
          <button
            v-if="ignoreLabel"
            @click="closeModal"
            class="btn btn-info">
            {{ ignoreLabel }}
          </button>
          <button
            v-if="negativeLabel"
            :disabled="!negativeAction"
            @click="handleNegative"
            class="btn btn-secondary mx-1">
            {{ negativeLabel || 'CANCELAR' }}
          </button>
          <button
            @click="handlePositive"
            class="btn btn-primary mx-1">
            {{ positiveLabel || 'ACEPTAR' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * You can use a dynamic instance importing "instance" and executing:
 * instance({
 *   header: 'My title',
 *   statement: 'the content',
 *   positiveLabel: 'Accept',
 *   ...otherProps
 * })
 */
import Vue from 'vue'
import $ from 'jquery'

const component = {
  props: {
    // If true needs to mount from the caller (instance.$mount(point))
    noMount: Boolean,
    // IF true avoids to show close button
    noClose: Boolean,
    // callback for positive click
    positiveAction: Function,
    // text for positive button
    positiveLabel: String,
    // callback for negative click
    negativeAction: Function,
    // text for negative button
    negativeLabel: String,
    ignoreLabel: String,
    // text body
    statement: String,
    // Title of dialog
    header: String,
    // Show exclamation icon instead of message icon
    error: Boolean,
    // Show wrench icon instead of message icon
    maintenance: Boolean,
    // Indicates whether the statement should be rendered as html or not
    html: Boolean
  },

  methods: {
    closeModal (e) {
      if (e.target === this.$el) $(this.$el).modal('hide')

      else e.stopPropagation()
    },

    handlePositive (e) {
      if (this.positiveAction) this.positiveAction(e)
      $(this.$el).modal('hide')
    },

    handleNegative (e) {
      this.negativeAction(e)
      $(this.$el).modal('hide')
    }
  },

  created () {
    if (!this.noMount) this.$mount(this.$refs.dialogs)
  },

  mounted () {
    $(this.$el).data().keyboard = !this.noClose

    $(this.$el).modal('show')

    $(this.$el).on('hidden.bs.modal', e => {
      this.$el.remove()
      this.$destroy()
    })
  }
}

export default component

const ComponentClass = Vue.extend(component)

export const instance = props => new ComponentClass({ propsData: props })
</script>

<style lang="scss">
  @import '/../../scss/breakpoints';

  #actionModal {
    background-color: rgba(0, 0, 0, 0.5);

    & .action-close {
      position: absolute;
      top: 0.25rem;
      right: 0.5rem;
    }
  }

  @media screen and (max-width: map-get($grid-breakpoints, "sm")) {
    #actionModal {
      & .btn {
        flex: 1;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/ActionDialog.vue